const TUI_LITHUANIAN_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Numeris', 'Kortelės numeris'],
  cardExpiry: ['Galioja iki', 'Galioja iki']
};
const TUI_LITHUANIAN_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Vientisa spalva', 'Gradientas'],
  toolbarTools: {
    undo: 'Atšaukti',
    redo: 'Perdaryti',
    font: 'Šriftas',
    fontStyle: 'Šrifto stilius',
    fontSize: 'Šrifto dydis',
    bold: 'Paryškintas',
    italic: 'Kursyvas',
    underline: 'Pabrauktas',
    strikeThrough: 'Perbrauktas',
    justify: 'Lygiuoti',
    justifyLeft: 'Lygiuoti kairėje',
    justifyCenter: 'Lygiuoti centre',
    justifyRight: 'Lygiuoti dešinėje',
    justifyFull: 'Lygiuoti į plotį',
    list: 'Sąrašas',
    indent: 'Įtraukti',
    outdent: 'Ištraukti',
    unorderedList: 'Nenumeruotas sąrašas',
    orderedList: 'Numeruotas sąrašas',
    quote: 'Citata',
    foreColor: 'Spalva',
    backColor: 'Fono spalva',
    hiliteColor: 'Paryškinimo spalva',
    clear: 'Išvalyti',
    link: 'Nuoroda',
    attach: 'Prisegti failą',
    tex: 'Įterpti TeX',
    code: 'Kodas',
    image: 'Įterpti vaizdą',
    insertHorizontalRule: 'Įterpti horizontalią liniją',
    superscript: 'Viršutinis indeksas',
    subscript: 'Apatinis indeksas',
    insertTable: 'Įterpti lentelę',
    insertGroup: 'Įterpti grupę',
    hiliteGroup: 'Paryškinti grupę',
    removeGroup: 'Pašalinti grupę',
    insertAnchor: 'Įterpti inkarą',
    mergeCells: 'Sujungti langelius',
    splitCells: 'Padalinti langelius',
    rowsColumnsManaging: 'Tvarkyti eilutes ir stulpelius',
    cellColor: 'Langelio spalva',
    setDetails: 'Nustatyti išsamią informaciją',
    removeDetails: 'Pašalinti išsamią informaciją'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'inkaras'
  },
  editorTableCommands: [['Įterpti stulpelį prieš', 'Įterpti stulpelį po'], ['Įterpti eilutę prieš', 'Įterpti eilutę po'], ['Ištrinti stulpelį', 'Ištrinti eilutę']],
  editorCodeOptions: ['Kodas tekste', 'Kodas bloke'],
  editorFontOptions: {
    small: 'Mažas',
    large: 'Didelis',
    normal: 'Normalus',
    title: 'Pavadinimas',
    subtitle: 'Antraštė'
  }
};
const TUI_LITHUANIAN_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Rodyti/Slėpti',
  paginationTexts: {
    pages: 'Puslapiai',
    linesPerPage: 'Eilučių per puslapį',
    of: 'iš'
  }
};
const TUI_LITHUANIAN_LANGUAGE_COUNTRIES = {
  AD: 'Andora',
  AE: 'Jungtiniai Arabų Emyratai',
  AF: 'Afganistanas',
  AG: 'Antigva ir Barbuda',
  AI: 'Angilija',
  AL: 'Albanija',
  AM: 'Armėnija',
  AO: 'Angola',
  AR: 'Argentina',
  AT: 'Austrija',
  AU: 'Australija',
  AW: 'Aruba',
  AZ: 'Azerbaidžanas',
  BA: 'Bosnija ir Hercegovina',
  BB: 'Barbadosas',
  BD: 'Bangladešas',
  BE: 'Belgija',
  BF: 'Burkina Fasas',
  BG: 'Bulgarija',
  BH: 'Bahreinas',
  BI: 'Burundis',
  BJ: 'Beninas',
  BL: 'Šv. Bartolomėjus',
  BM: 'Bermudai',
  BN: 'Brunėjus',
  BO: 'Bolivija',
  BQ: 'Karibų Nyderlandai',
  BR: 'Brazilija',
  BS: 'Bahamos',
  BT: 'Butanas',
  BW: 'Botsvana',
  BY: 'Baltarusija',
  BZ: 'Belizas',
  CA: 'Kanada',
  CD: 'Kongas - Kinšasa',
  CF: 'Centrinės Afrikos Respublika',
  CG: 'Kongas - Brazavilis',
  CH: 'Šveicarija',
  CI: 'Dramblio Kaulo Krantas',
  CL: 'Čilė',
  CM: 'Kamerūnas',
  CN: 'Kinija',
  CO: 'Kolumbija',
  CR: 'Kosta Rika',
  CU: 'Kuba',
  CV: 'Žaliasis Kyšulys',
  CW: 'Kiurasao',
  CY: 'Kipras',
  CZ: 'Čekija',
  DE: 'Vokietija',
  DJ: 'Džibutis',
  DK: 'Danija',
  DM: 'Dominika',
  DO: 'Dominikos Respublika',
  DZ: 'Alžyras',
  EC: 'Ekvadoras',
  EE: 'Estija',
  EG: 'Egiptas',
  ER: 'Eritrėja',
  ES: 'Ispanija',
  ET: 'Etiopija',
  FI: 'Suomija',
  FJ: 'Fidžis',
  FK: 'Falklando salos',
  FM: 'Mikronezijos Federacinės Valstijos',
  FR: 'Prancūzija',
  GA: 'Gabonas',
  GB: 'Jungtinė Karalystė',
  GD: 'Grenada',
  GE: 'Gruzija',
  GF: 'Prancūzijos Gviana',
  GH: 'Gana',
  GI: 'Gibraltaras',
  GL: 'Grenlandija',
  GM: 'Gambija',
  GN: 'Gvinėja',
  GP: 'Gvadelupa',
  GQ: 'Pusiaujo Gvinėja',
  GR: 'Graikija',
  GT: 'Gvatemala',
  GW: 'Bisau Gvinėja',
  GY: 'Gajana',
  HK: 'Honkongas',
  HN: 'Hondūras',
  HR: 'Kroatija',
  HT: 'Haitis',
  HU: 'Vengrija',
  ID: 'Indonezija',
  IE: 'Airija',
  IL: 'Izraelis',
  IN: 'Indija',
  IQ: 'Irakas',
  IR: 'Iranas',
  IS: 'Islandija',
  IT: 'Italija',
  JM: 'Jamaika',
  JO: 'Jordanija',
  JP: 'Japonija',
  KE: 'Kenija',
  KG: 'Kirgizija',
  KH: 'Kambodža',
  KM: 'Komorai',
  KN: 'Sent Kitsas ir Nevis',
  KP: 'Šiaurės Korėja',
  KR: 'Pietų Korėja',
  KW: 'Kuveitas',
  KY: 'Kaimanų salos',
  KZ: 'Kazachstanas',
  LA: 'Laosas',
  LB: 'Libanas',
  LC: 'Sent Lusija',
  LI: 'Lichtenšteinas',
  LK: 'Šri Lanka',
  LR: 'Liberija',
  LS: 'Lesotas',
  LT: 'Lietuva',
  LU: 'Liuksemburgas',
  LV: 'Latvija',
  LY: 'Libija',
  MA: 'Marokas',
  MC: 'Monakas',
  MD: 'Moldova',
  ME: 'Juodkalnija',
  MF: 'Šv. Martynas',
  MG: 'Madagaskaras',
  MK: 'Šiaurės Makedonija',
  ML: 'Malis',
  MM: 'Mianmaras (Birma)',
  MN: 'Mongolija',
  MO: 'Makao',
  MQ: 'Martinika',
  MR: 'Mauritanija',
  MS: 'Montseratas',
  MT: 'Malta',
  MU: 'Mauricijus',
  MV: 'Maldyvai',
  MW: 'Malavis',
  MX: 'Meksika',
  MY: 'Malaizija',
  MZ: 'Mozambikas',
  NA: 'Namibija',
  NC: 'Naujoji Kaledonija',
  NE: 'Nigeris',
  NG: 'Nigerija',
  NI: 'Nikaragva',
  NL: 'Nyderlandai',
  NO: 'Norvegija',
  NP: 'Nepalas',
  NZ: 'Naujoji Zelandija',
  OM: 'Omanas',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'Prancūzijos Polinezija',
  PG: 'Papua Naujoji Gvinėja',
  PH: 'Filipinai',
  PK: 'Pakistanas',
  PL: 'Lenkija',
  PT: 'Portugalija',
  PW: 'Palau',
  PY: 'Paragvajus',
  QA: 'Kataras',
  RE: 'Reunjonas',
  RO: 'Rumunija',
  RS: 'Serbija',
  RU: 'Rusija',
  RW: 'Ruanda',
  SA: 'Saudo Arabija',
  SB: 'Saliamono salos',
  SC: 'Seišeliai',
  SD: 'Sudanas',
  SE: 'Švedija',
  SG: 'Singapūras',
  SH: 'Šv. Elena',
  SI: 'Slovėnija',
  SK: 'Slovakija',
  SL: 'Siera Leonė',
  SM: 'San Marinas',
  SN: 'Senegalas',
  SO: 'Somalis',
  SR: 'Surinamas',
  ST: 'San Tomė ir Prinsipė',
  SV: 'Salvadoras',
  SX: 'Sint Martenas',
  SY: 'Sirija',
  SZ: 'Esvatinis',
  TC: 'Terkso ir Kaikoso salos',
  TD: 'Čadas',
  TG: 'Togas',
  TH: 'Tailandas',
  TJ: 'Tadžikistanas',
  TL: 'Rytų Timoras',
  TM: 'Turkmėnistanas',
  TN: 'Tunisas',
  TO: 'Tonga',
  TR: 'Turkija',
  TT: 'Trinidadas ir Tobagas',
  TW: 'Taivanas',
  TZ: 'Tanzanija',
  UA: 'Ukraina',
  UG: 'Uganda',
  US: 'Jungtinės Valstijos',
  UY: 'Urugvajus',
  UZ: 'Uzbekistanas',
  VC: 'Šv. Vincentas ir Grenadinai',
  VE: 'Venesuela',
  VG: 'Didžiosios Britanijos Mergelių salos',
  VN: 'Vietnamas',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovas',
  YE: 'Jemenas',
  YT: 'Majotas',
  ZA: 'Pietų Afrika',
  ZM: 'Zambija',
  ZW: 'Zimbabvė',
  AC: 'Ascension sala',
  AS: 'Amerikos Samoa',
  AX: 'Alandų salos',
  CC: 'Kokosų (Kilingo) salos',
  CK: 'Kuko salos',
  CX: 'Kalėdų sala',
  EH: 'Vakarų Sachara',
  FO: 'Farerų salos',
  GG: 'Gernsis',
  GU: 'Guamas',
  IM: 'Meno sala',
  JE: 'Džersis',
  IO: 'Britų Indijos vandenyno teritorija',
  KI: 'Kiribatis',
  MH: 'Maršalo Salos',
  MP: 'Šiaurinės Marianų Salos',
  NF: 'Norfolko sala',
  NR: 'Nauru',
  NU: 'Niujė',
  PM: 'Sen Pjeras ir Mikelonas',
  PR: 'Puerto Rikas',
  PS: 'Palestina',
  SJ: 'Svalbardas ir Jan Majenas',
  SS: 'Pietų Sudanas',
  TA: 'Tristanas da Kunja',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Šventasis Sostas',
  VI: 'Mergelių salos',
  WF: 'Volisas ir Futūna'
};
const TUI_LITHUANIAN_LANGUAGE_CORE = {
  months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
  close: 'Uždaryti',
  clear: 'Notīrīt lauku',
  nothingFoundMessage: 'Nieko nerasta',
  defaultErrorMessage: 'Reikšmė neteisinga',
  spinTexts: ['Ankstesnis', 'Kitas'],
  shortWeekDays: ['Pir', 'Ant', 'Tre', 'Ket', 'Pen', 'Šeš', 'Sek'],
  countries: TUI_LITHUANIAN_LANGUAGE_COUNTRIES
};
const TUI_LITHUANIAN_LANGUAGE_KIT = {
  cancel: 'Atšaukti',
  done: 'Atlikta',
  more: 'Daugiau',
  otherDate: 'Kita data...',
  showAll: 'Rodyti viską',
  hide: 'Slėpti',
  mobileCalendarTexts: ['Pasirinkite dieną', 'Pasirinkite intervalą', 'Pasirinkite dienas'],
  range: ['nuo', 'iki'],
  countTexts: ['Plius', 'Minus'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['Rodyti slaptažodį', 'Slėpti slaptažodį'],
  copyTexts: ['Kopijuoti', 'Nukopijuota'],
  shortCalendarMonths: ['Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rgp', 'Rgs', 'Spa', 'Lap', 'Gru'],
  pagination: ['Ankstesnis puslapis', 'Kitas puslapis'],
  fileTexts: {
    loadingError: 'Įkėlimas nepavyko',
    preview: 'Peržiūra',
    remove: 'Pašalinti'
  },
  inputFileTexts: {
    defaultLabelSingle: 'arba numeskite\u00A0čia',
    defaultLabelMultiple: 'arba numeskite\u00A0juos\u00A0čia',
    defaultLinkSingle: 'Pasirinkite failą',
    defaultLinkMultiple: 'Pasirinkite failus',
    maxSizeRejectionReason: 'Failas yra didesnis nei',
    formatRejectionReason: 'Neteisingas failo tipas',
    drop: 'Numeskite failą čia',
    dropMultiple: 'Numeskite failus čia'
  },
  multiSelectTexts: {
    all: 'Pasirinkti visus',
    none: 'Pasirinkti nė vieno'
  },
  confirm: {
    yes: 'Taip',
    no: 'Ne'
  },
  previewTexts: {
    rotate: 'Pasukti'
  },
  zoomTexts: {
    zoomOut: 'Mažinti',
    zoomIn: 'Didinti',
    reset: 'Atstatyti'
  },
  phoneSearch: 'Ievadiet valsti vai kodu'
};
const TUI_LITHUANIAN_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_LITHUANIAN_LANGUAGE = {
  name: 'lithuanian',
  ...TUI_LITHUANIAN_LANGUAGE_CORE,
  ...TUI_LITHUANIAN_LANGUAGE_KIT,
  ...TUI_LITHUANIAN_LANGUAGE_ADDON_TABLE,
  ...TUI_LITHUANIAN_LANGUAGE_ADDON_COMMERCE,
  ...TUI_LITHUANIAN_LANGUAGE_ADDON_EDITOR,
  ...TUI_LITHUANIAN_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_LITHUANIAN_LANGUAGE, TUI_LITHUANIAN_LANGUAGE_ADDON_COMMERCE, TUI_LITHUANIAN_LANGUAGE_ADDON_EDITOR, TUI_LITHUANIAN_LANGUAGE_ADDON_TABLE, TUI_LITHUANIAN_LANGUAGE_CORE, TUI_LITHUANIAN_LANGUAGE_COUNTRIES, TUI_LITHUANIAN_LANGUAGE_KIT, TUI_LITHUANIAN_LANGUAGE_LAYOUT };
